import React, { Component } from 'react';
import { Row, Col, Divider } from 'antd';
import PropTypes from 'prop-types';
import Chart from '../chart/chart';
import Pricetable from '../priceTable/priceTable';
import TooltipComponent from '../../../../../../CommonComponents/Info/Tooltip/TooltipComponent';
import {
  DataHeading,
  DataValue,
  DisplayFlex,
  JustifyBetween,
} from '../../../../../../CommonComponents/commonStyles';
import ClipDivision from '../../../../../../CommonComponents/ClipDivison/ClipDivision';
import {
  DivHeading,
  UnderlyingFund,
  ProgressCircle,
  ProgressLabelContainer,
  ProgressLabel,
  Goal,
  CashSquare,
  StockSquare,
  UnderlyingFundParagraph,
  Benchmark,
  Management,
} from '../../styles';
import {
  ProgressUpdated,
  DisplayFlexUpdated,
  IODDatepicker,
  DisplayFlexDP,
  IODSearchButton,
  MobilePoolDesc,
  ExpandableDiv,
  DetailLabel,
} from './styles';
import moment from 'moment';
import { recordError } from '../../../../../../utils/commonUtil';
import { CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';
import GlobalModal from "../../../../../../CommonComponents/AlertModal/GlobalModal";

let priceTable = [];
let buttonText = '';

const dateFormatList = 'MM/DD/YYYY';

export default class MobileExpanded extends Component {
  constructor() {
    super();
    this.state = {
      startDate: moment(new Date()).subtract(90, 'days'),
      endDate: new Date(),
      submit: false,
      priceTableData: [],
      accountType: '',
      apiCalled: false,
      resetDate: true,
    };
  }
  componentWillReceiveProps(np) {
    this.setState({ accountType: np.accountType });
  }

  componentDidMount() {
    this.setState({ accountType: this.props.accountType });
  }

  setStartDate = (date) => {
    if (date) {
      this.setState({
        startDate: date._d,
      });
    }
  };

  setEndDate = (date) => {
    if (date) {
      this.setState({
        endDate: date._d,
      });
    }
  };

  disableDate = (current, isStartDate = false) => {
    if (isStartDate) {
      return current && current.valueOf() >= moment(this.state.endDate);
    } else {
      return current && current.valueOf() > moment(this.state.endDate);
    }
  };

  filterdate = () => {
    try {
      this.setState({ resetDate: !this.state.resetDate });
      this.setState({ apiCalled: true });
      let startDate = new Date(this.state.startDate);
      let endDate = new Date(this.state.endDate);
            
      let resultProductData = priceTable.filter(function(filterdate) {
        let date = new Date(filterdate.date);
        return date >= startDate && date <= endDate;
      });
      
      this.setState({
        priceTableData: resultProductData,
        submit: !this.state.submit,
      });
      if (this.state.submit) {
        let elm = document.getElementsByClassName(
          'ant-calendar-picker-input ant-input'
        );        
        if (elm && elm.length > 0) {
          elm[0].value = '';
          elm[1].value = '';
        }
        this.setState({
          startDate: moment(new Date()).subtract(90, 'days'),
          endDate: new Date(),
          priceTableData: priceTable,
        });
      }
    } catch (error) {      
      recordError(error);
    }
  }; 

  getAlert(link) {
    GlobalModal({ 
      handleOk: ()=>{ window.open(link, "_blank")}, 
      contents: "Clicking OK will open a new window to Vanguard.com, a website that is not hosted by Vanguard Charitable.",
      type: "confirm"
    });
  }

  modifyAnchorTagMobile(url, percentage) {
    let tempArray = [];
    if (url && url !== 'Benchmark Return') {
      const link = url.match(/href=(\"|\')(.*?)(\"|\')/)[2];
      const linkText = url.match(/\>(.*?)\<\/a\>/)[1];
      tempArray.push(link);
      tempArray.push(
        `<a href="javascript:" target="_blank">${linkText} ${
          percentage ? percentage + '%' : ''
        }</a>`
      );
    } else if (url) {
      tempArray.push(url);
    }
    return tempArray;
  }

  render() {
    let chartData = this.props.data;
    if (chartData) {
      chartData = JSON.parse(JSON.stringify(chartData));
      delete chartData['benchmark'];
      const benchmark = chartData.expandedData.find(
        (o) => o.field_fund === 'Benchmark Return'
      );
      chartData.benchmark = benchmark ? benchmark : {};
    }

    priceTable = this.props.data.priceTable;

    switch (this.props.tabIndex) {
      case 0:
        return (
          <ExpandableDiv data-test='myInvestmentExpanded'>
            {this.props.data.expandedData.map((item, index) => {
              let urlArray = this.modifyAnchorTagMobile(
                item.field_fund,
                item.field_funds_percentage
              );

              return (
                <div key={index}>
                  <div className='textWrapper'>
                    {urlArray.length === 1 ? (
                      <UnderlyingFundParagraph>
                        {urlArray[0]}
                      </UnderlyingFundParagraph>
                    ) : (
                      <DetailLabel>
                        <UnderlyingFund
                          className='mb1'
                          onClick={this.getAlert.bind(this, urlArray[0])}
                          dangerouslySetInnerHTML={{ __html: urlArray[1] }}
                        />
                      </DetailLabel>
                    )}
                  </div>
                  <div>
                    <Row>
                      <Col xs={13}>
                        <DataHeading>Available Balance</DataHeading>
                        <DataValue>
                          {!item.availableBalance ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.availableBalance}</>
                          )}
                        </DataValue>
                      </Col>
                      <Col xs={11}>
                        <DataHeading>Available units</DataHeading>
                        <DataValue>
                          {!item.availableUnits ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.availableUnits}</>
                          )}
                        </DataValue>
                      </Col>
                    </Row>
                    <Divider className='my2' />
                    <Row>
                      <Col xs={13}>
                        <DataHeading>
                          Expense ratios
                        </DataHeading>
                        <DataValue>
                          {item.expRatio === '' ||
                          item.expRatio === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.expRatio}%</>
                          )}
                        </DataValue>
                      </Col>
                      <Col xs={11} className='mb2'>
                        <DataHeading>
                          Current NAV
                        </DataHeading>
                        <DataValue>
                          {item.currentNAV === '' ||
                          item.currentNAV === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.currentNAV}</>
                          )}
                        </DataValue>
                      </Col>
                    </Row>
                    <Divider className='my2' />
                  </div>
                </div>
              );
            })}
            <div>
              {/* <div>
                <DivHeading paddingBottom='15px' className='navy-color'>
                  Returns chart
                </DivHeading>
                <Chart data-test="mi_chart" mobile data={chartData} />
              </div> */}
              <Divider />
              <div>
                <DivHeading className='navy-color'>
                  Search for Historical NAV
                </DivHeading>
                <DisplayFlexDP>
                  <IODDatepicker
                    data-test="mi_startDate"
                    onChange={this.setStartDate}
                    placeholder='Select Start Date'
                    disabledDate={(current) => this.disableDate(current, true)}
                    format={dateFormatList}
                    value={moment(this.state.startDate)}
                    className='mb2 mr1'
                  />
                  <IODDatepicker
                    data-test="mi_endDate"
                    onChange={this.setEndDate}
                    placeholder='Select End Date'
                    format={dateFormatList}
                    disabledDate={(current) => this.disableDate(current)}
                    value={moment(this.state.endDate)}
                    className='mb2'
                  />
                </DisplayFlexDP>

                {this.state.submit === false ? (
                  <div className='w50'>
                    <IODSearchButton
                      onClick={this.filterdate}
                      className='mb3 w50 search'
                    >
                      Search
                    </IODSearchButton>
                  </div>
                ) : (
                  <div className='w75'>
                    <IODSearchButton
                      onClick={this.filterdate}
                      className='mb3 w50 search'
                    >
                      Reset to default
                    </IODSearchButton>
                  </div>
                )}

                <div className='table-field'>
                  {this.state.apiCalled ? (
                    <Pricetable
                      data={this.state.priceTableData}
                      accountType={this.state.accountType}
                    />
                  ) : (
                    <Pricetable
                      data={priceTable}
                      accountType={this.state.accountType}
                    />
                  )}
                </div>
              </div>
            </div>
            <Divider className='my2' />
            <MobilePoolDesc>
              <DataValue className='navy-color'>Description</DataValue>
              {this.props.data.description ? (
                <DataHeading>{this.props.data.description}</DataHeading>
              ) : (
                <DivHeading> &mdash; </DivHeading>
              )}
            </MobilePoolDesc>
            <Divider className='my2' />
            <div className=''>
              <div>
                <DivHeading className='navy-color'>
                  Risk/granting time horizon
                </DivHeading>
                <ClipDivision risk={this.props.data.risk} tab={'mi'} />
              </div>
              {this.props.data.type === 'ps' && (
                <ProgressCircle>
                  <DivHeading className='navy-color'>
                    Target Allocation
                  </DivHeading>
                  <DisplayFlex>
                    <ProgressUpdated
                      data-test="mi_progress"
                      type='circle'
                      percent={this.props.data.value1}
                      strokeWidth={10}
                      width={50}
                      strokeLinecap='square'
                      className='mt2'
                      strokeColor='#0098db'
                      format={() => ''}
                    />
                    <div className='mt2'>
                      <ProgressLabelContainer>
                        <DisplayFlex>
                          <CashSquare color='#0098db' />
                          <ProgressLabel>
                            {this.props.data.value1 === '' ? (
                              <>&mdash;</>
                            ) : (
                              <>
                                {this.props.data.value1}%{' '}
                                {this.props.data.label1}
                              </>
                            )}
                          </ProgressLabel>
                        </DisplayFlex>
                        <DisplayFlex>
                          <StockSquare />
                          <ProgressLabel>
                            {this.props.data.value2 === '' ? (
                              <>&mdash;</>
                            ) : (
                              <>
                                {this.props.data.value2}%{' '}
                                {this.props.data.label2}
                              </>
                            )}
                          </ProgressLabel>
                        </DisplayFlex>
                      </ProgressLabelContainer>
                    </div>
                  </DisplayFlex>
                </ProgressCircle>
              )}
              <div className='mb-25'>
                <DivHeading className='navy-color'>Goal</DivHeading>
                <Goal>
                  {this.props.data.goal === '' ? (
                    <>&mdash;</>
                  ) : (
                    <>{this.props.data.goal}</>
                  )}
                </Goal>
              </div>
              {this.props.data.type !== 'ps' && (
                <div className='mb-25'>
                  <DivHeading className='navy-color'>Benchmark</DivHeading>
                  <Benchmark>
                    {this.props.data.benchmark ? (
                      <p className='extra-small'>{this.props.data.benchmark}</p>
                    ) : (
                      <>&mdash;</>
                    )}
                  </Benchmark>
                </div>
              )}
              <div className='mb-25'>
                <DivHeading className='navy-color'>
                  Management
                  <TooltipComponent text="Active funds focus on outperforming the market compared to a specific benchmark through a portfolio manager's selections. Passive funds seek to mimic benchmarks by tracking an index." />
                </DivHeading>
                <Management>
                  {this.props.data.management === '' ? (
                    <>&mdash;</>
                  ) : (
                    <>{this.props.data.management}</>
                  )}
                </Management>
              </div>
            </div>
          </ExpandableDiv>
        );
      case 1:
        return (
          <ExpandableDiv data-test='portfolioSolutionsExpanded'>
            {this.props.data.expandedData.map((item, index) => {              
              let urlArray = this.modifyAnchorTagMobile(
                item.field_fund,
                item.field_funds_percentage
              );
              return (
                <div key={index}>
                  {urlArray.length === 1 ? (
                    <DetailLabel>
                      <UnderlyingFundParagraph>
                        {urlArray[0]}
                      </UnderlyingFundParagraph>
                    </DetailLabel>
                  ) : (
                    <DetailLabel>
                      <UnderlyingFund
                        data-test={`psunderlyinglink${index}`}
                        className='mb1'
                        onClick={this.getAlert.bind(this, urlArray[0])}
                        dangerouslySetInnerHTML={{ __html: urlArray[1] }}
                      />
                    </DetailLabel>
                  )}
                  <div>
                    <JustifyBetween>
                      <div>
                        <DataHeading>Qtr</DataHeading>
                        <DataValue>
                          {item.returnsYTD === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.returnsYTD}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>1 year</DataHeading>
                        <DataValue>
                          {item.oneY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.oneY}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>5 year</DataHeading>
                        <DataValue>
                          {item.fiveY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.fiveY}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>10 year</DataHeading>
                        <DataValue>
                          {item.tenY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.tenY}%</>
                          )}
                        </DataValue>
                      </div>
                    </JustifyBetween>
                    <Divider className='my2' />
                    <JustifyBetween className='mb2'>
                      {/* Will be needed for future
                        <div>
                        <DataHeading>
                          Expense ratios <br />
                          (Standard)
                        </DataHeading>
                        <DataValue>
                          {item.stdExpRatio === '' ||
                          item.stdExpRatio === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.stdExpRatio}%</>
                          )}
                        </DataValue>
                      </div> */}
                      <div>
                        <DataHeading>
                          Expense ratios
                        </DataHeading>
                        <DataValue>
                          {item.selExpRatio === '' ||
                          item.selExpRatio === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.selExpRatio}%</>
                          )}
                        </DataValue>
                      </div>
                    
                      <div>
                        <DataHeading>
                          Current NAV
                        </DataHeading>
                        <DataValue>
                          {item.CurrentNAV === '' ||
                          item.CurrentNAV === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.CurrentNAV}</>
                          )}
                        </DataValue>{' '}
                      </div>
                    </JustifyBetween>
                  </div>
                </div>
              );
            })}
            <div>
              {/* <div>
                <DivHeading paddingBottom='15px' className='navy-color'>
                  Returns chart
                </DivHeading>
                <Chart mobile data={chartData} />
              </div> */}
              <Divider />
              <div>
                <DivHeading className='navy-color'>
                  Search for Historical NAV
                </DivHeading>
                <DisplayFlexDP>
                  <IODDatepicker
                    data-test={`ps_startDate`}
                    onChange={this.setStartDate}
                    placeholder='Select Start Date'
                    disabledDate={(current) => this.disableDate(current, true)}
                    format={dateFormatList}
                    value={moment(this.state.startDate)}
                  />
                  <IODDatepicker
                    data-test={`ps_endDate`}
                    onChange={this.setEndDate}
                    placeholder='Select End Date'
                    format={dateFormatList}
                    disabledDate={(current) => this.disableDate(current)}
                    value={moment(this.state.endDate)}
                  />
                </DisplayFlexDP>

            <CapsuleButton text= {
                    (buttonText =
                      this.state.submit === false
                        ? 'Search'
                        : 'Reset to default')
                  } 
                  top="10px"
                  onClick={this.filterdate}
                  whiteBackground
                  styles="w50"
                  />

                <div className='table-field'>
                  {this.state.apiCalled ? (
                    <Pricetable
                      data={this.state.priceTableData}
                      accountType={this.state.accountType}
                    />
                  ) : (
                    <Pricetable
                      data={priceTable}
                      accountType={this.state.accountType}
                    />
                  )}
                </div>
              </div>
            </div>
            <Divider className='my2' />
            <MobilePoolDesc>
              <DataValue className='navy-color'>Description</DataValue>
              {this.props.data.description ? (
                <DataHeading>{this.props.data.description}</DataHeading>
              ) : (
                <DivHeading> &mdash; </DivHeading>
              )}
            </MobilePoolDesc>
            <Divider className='my2' />
            <div>
              <div>
                <DivHeading className='navy-color'>
                  Risk/granting time horizon
                </DivHeading>
                <ClipDivision risk={this.props.data.risk} tab={'ps'} />
              </div>

              <ProgressCircle>
                <DivHeading className='navy-color'>
                  Target Allocation
                </DivHeading>
                <DisplayFlex>
                  <ProgressUpdated
                    data-test="ps_progress"
                    type='circle'
                    percent={parseInt(this.props.data.value1)}
                    strokeWidth={10}
                    width={50}
                    strokeLinecap='square'
                    className='mt2'
                    strokeColor={'#0098db'}
                    format={() => ''}
                  />
                  <div className=''>
                    <ProgressLabelContainer>
                      <DisplayFlexUpdated>
                        <CashSquare color='#0098db' />
                        <ProgressLabel>
                          {this.props.data.value1 === '' ? (
                            <>&mdash;</>
                          ) : (
                            <>
                              {this.props.data.value1}% {this.props.data.label1}
                            </>
                          )}
                        </ProgressLabel>
                      </DisplayFlexUpdated>
                      <DisplayFlexUpdated>
                        <StockSquare />
                        <ProgressLabel>
                          {this.props.data.value2 === '' ? (
                            <>&mdash;</>
                          ) : (
                            <>
                              {this.props.data.value2}% {this.props.data.label2}
                            </>
                          )}
                        </ProgressLabel>
                      </DisplayFlexUpdated>
                    </ProgressLabelContainer>
                  </div>
                </DisplayFlex>
              </ProgressCircle>
              <div className='mb-25'>
                <DivHeading className='navy-color'>Goal</DivHeading>
                <Goal>
                  {this.props.data.goal === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.goal}</>
                  )}
                </Goal>
              </div>
              <div className='mb-25'>
                <DivHeading className='navy-color'>
                  Management
                  <TooltipComponent text="Active funds focus on outperforming the market compared to a specific benchmark through a portfolio manager's selections. Passive funds seek to mimic benchmarks by tracking an index." />
                </DivHeading>
                <Management>
                  {this.props.data.management === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.management}</>
                  )}
                </Management>
              </div>
            </div>
          </ExpandableDiv>
        );
      case 2:
        return (
          <ExpandableDiv data-test='portfolioBuildersExpanded'>
            {this.props.data.expandedData.map((item, index) => {
              let urlArray = this.modifyAnchorTagMobile(
                item.field_fund,
                item.field_funds_percentage
              );
              return (
                <div key={index}>
                  {urlArray.length === 1 ? (
                    <UnderlyingFundParagraph>
                      {urlArray[0]}
                    </UnderlyingFundParagraph>
                  ) : (
                    <DetailLabel>
                      <UnderlyingFund
                        data-test={`pbunderlyinglink${index}`}
                        className='mb1'
                        onClick={this.getAlert.bind(this, urlArray[0])}
                        dangerouslySetInnerHTML={{ __html: urlArray[1] }}
                      />
                    </DetailLabel>
                  )}
                  <div>
                    <JustifyBetween>
                      <div>
                        <DataHeading>Qtr</DataHeading>
                        <DataValue>
                          {item.returnsYTD === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.returnsYTD}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>1 year</DataHeading>
                        <DataValue>
                          {item.oneY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.oneY}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>5 year</DataHeading>
                        <DataValue>
                          {item.fiveY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.fiveY}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>10 year</DataHeading>
                        <DataValue>
                          {item.tenY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.tenY}%</>
                          )}
                        </DataValue>
                      </div>
                    </JustifyBetween>
                    <Divider className='my2' />
                    <JustifyBetween>
                      {/* <div>
                        <DataHeading>
                          Expense ratios <br />
                          (Standard)
                        </DataHeading>
                        <DataValue>
                          {item.stdExpRatio === '' ||
                          item.stdExpRatio === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.stdExpRatio}%</>
                          )}
                        </DataValue>
                      </div> */}
                      <div>
                        <DataHeading>
                          Expense ratios
                        </DataHeading>
                        <DataValue>
                          {item.selExpRatio === '' ||
                          item.selExpRatio === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.selExpRatio}%</>
                          )}
                        </DataValue>
                      </div>
                      <div className='mb2'>
                        <DataHeading>
                          Current NAV
                        </DataHeading>
                        <DataValue>
                          {item.CurrentNAV === '' ||
                          item.CurrentNAV === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.CurrentNAV}</>
                          )}
                        </DataValue>
                      </div>
                    </JustifyBetween>
                  </div>
                </div>
              );
            })}
            <div>
              {/* <div>
                <DivHeading paddingBottom='15px' className='navy-color'>
                  Returns chart
                </DivHeading>
                <Chart mobile data={chartData} />
              </div> */}
              <Divider />
              <div>
                <DivHeading className='navy-color'>
                  Search for Historical NAV
                </DivHeading>
                <DisplayFlexDP>
                  <IODDatepicker
                    data-test="pb_startDate"
                    onChange={this.setStartDate}
                    placeholder='Select Start Date'
                    disabledDate={(current) => this.disableDate(current, true)}
                    format={dateFormatList}
                    value={moment(this.state.startDate)}
                  />
                  <IODDatepicker
                    data-test="pb_endDate"
                    onChange={this.setEndDate}
                    placeholder='Select End Date'
                    format={dateFormatList}
                    disabledDate={(current) => this.disableDate(current)}
                    value={moment(this.state.endDate)}
                  />
                </DisplayFlexDP>
                <IODSearchButton onClick={this.filterdate} className='mb3 w50 '>
                  {
                    (buttonText =
                      this.state.submit === false
                        ? 'Search'
                        : 'Reset to default')
                  }
                </IODSearchButton>
                <div className='table-field'>
                  {this.state.apiCalled ? (
                    <Pricetable
                      data={this.state.priceTableData}
                      accountType={this.state.accountType}
                    />
                  ) : (
                    <Pricetable
                      data={priceTable}
                      accountType={this.state.accountType}
                    />
                  )}
                </div>
              </div>
            </div>
            <Divider className='my2' />
            <MobilePoolDesc>
              <DataValue className='navy-color'>Description</DataValue>
              {this.props.data.description ? (
                <DataHeading>{this.props.data.description}</DataHeading>
              ) : (
                <DivHeading> &mdash; </DivHeading>
              )}
            </MobilePoolDesc>
            <Divider className='my2' />
            <div className=''>
              <div>
                <DivHeading className='navy-color'>
                  Risk/granting time horizon
                </DivHeading>
                <ClipDivision risk={this.props.data.risk} tab={'pb'} />
              </div>
              <div className='mb-25'>
                <DivHeading className='navy-color'>Goal</DivHeading>
                <Goal>
                  {this.props.data.goal === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.goal}</>
                  )}
                </Goal>
              </div>

              <div className='mb-25'>
                <DivHeading className='navy-color'>Benchmark</DivHeading>
                <Benchmark>
                  {this.props.data.benchmark === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.benchmark}</>
                  )}
                </Benchmark>
              </div>

              <div className='mb-25'>
                <DivHeading className='navy-color'>
                  Management
                  <TooltipComponent text="Active funds focus on outperforming the market compared to a specific benchmark through a portfolio manager's selections. Passive funds seek to mimic benchmarks by tracking an index." />
                </DivHeading>
                <Management>
                  {this.props.data.management === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.management}</>
                  )}
                </Management>
              </div>
            </div>
          </ExpandableDiv>
        );
      case 3:
        return (
          <ExpandableDiv data-test='valuesDrivenExpanded'>
            {this.props.data.expandedData.map((item, index) => {
              let urlArray = this.modifyAnchorTagMobile(
                item.field_fund,
                item.field_funds_percentage
              );
              return (
                <div key={index}>
                  {urlArray.length === 1 ? (
                    <DetailLabel>
                      <UnderlyingFundParagraph>
                        {urlArray[0]}
                      </UnderlyingFundParagraph>
                    </DetailLabel>
                  ) : (
                    <DetailLabel>
                      <UnderlyingFund
                        data-test={`vdunderlyinglink${index}`}
                        className='mb1'
                        onClick={this.getAlert.bind(this, urlArray[0])}
                        dangerouslySetInnerHTML={{ __html: urlArray[1] }}
                      />
                    </DetailLabel>
                  )}
                  <div>
                    <JustifyBetween>
                      <div>
                        <DataHeading>Qtr</DataHeading>
                        <DataValue>
                          {item.returnsYTD == '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.returnsYTD}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>1 year</DataHeading>
                        <DataValue>
                          {item.oneY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.oneY}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>5 year</DataHeading>
                        <DataValue>
                          {item.fiveY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.fiveY}%</>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>10 year</DataHeading>
                        <DataValue>
                          {item.tenY === '' ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.tenY}%</>
                          )}
                        </DataValue>
                      </div>
                    </JustifyBetween>
                    <Divider className='my2' />
                    <JustifyBetween>
                      {/* <div>
                        <DataHeading>
                          Expense ratios <br />
                          (Standard)
                        </DataHeading>
                        <DataValue>
                          {item.stdExpRatio === '' ||
                          item.stdExpRatio === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.stdExpRatio}%</>
                          )}
                        </DataValue>
                      </div> */}
                      <div>
                        <DataHeading>
                          Expense ratios
                        </DataHeading>
                        <DataValue>
                          {item.selExpRatio === '' ||
                          item.selExpRatio === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.selExpRatio}%</>
                          )}
                        </DataValue>
                      </div>
                      <div className='mb2'>
                        <DataHeading>
                          Current NAV
                        </DataHeading>
                        <DataValue>
                          {item.CurrentNAV === '' ||
                          item.CurrentNAV === undefined ? (
                            <> &mdash; </>
                          ) : (
                            <>{item.CurrentNAV}%</>
                          )}
                        </DataValue>
                      </div>
                    </JustifyBetween>
                  </div>
                </div>
              );
            })}
            <div>
                {/* <div>
                  <DivHeading paddingBottom='15px' className='navy-color'>
                    Returns chart
                  </DivHeading>
                  <Chart mobile data={chartData} />
                </div> */}
                <Divider />
              <div>
                <DivHeading className='navy-color'>
                  Search for Historical NAV
                </DivHeading>
                <DisplayFlexDP>
                  <IODDatepicker
                    data-test="vd_startDate"
                    onChange={this.setStartDate}
                    placeholder='Select Start Date'
                    disabledDate={(current) => this.disableDate(current, true)}
                    format={dateFormatList}
                    value={moment(this.state.startDate)}
                  />
                  <IODDatepicker
                    data-test="vd_endDate"
                    onChange={this.setEndDate}
                    placeholder='Select End Date'
                    format={dateFormatList}
                    disabledDate={(current) => this.disableDate(current)}
                    value={moment(this.state.endDate)}
                  />
                </DisplayFlexDP>
                <IODSearchButton onClick={this.filterdate} className='mb3 w50 '>
                  {
                    (buttonText =
                      this.state.submit === false
                        ? 'Search'
                        : 'Reset to default')
                  }
                </IODSearchButton>
                <div className='table-field'>
                  {this.state.apiCalled ? (
                    <Pricetable
                      data={this.state.priceTableData}
                      accountType={this.state.accountType}
                    />
                  ) : (
                    <Pricetable
                      data={priceTable}
                      accountType={this.state.accountType}
                    />
                  )}
                </div>
              </div>
            </div>
            <Divider className='my2' />
            <MobilePoolDesc>
              <DataValue className='navy-color'>Description</DataValue>
              {this.props.data.description ? (
                <DataHeading>{this.props.data.description}</DataHeading>
              ) : (
                <DivHeading> &mdash; </DivHeading>
              )}
            </MobilePoolDesc>
            <Divider className='my2' />
            <div className=''>
              <div>
                <DivHeading className='navy-color'>
                  Risk/granting time horizon
                </DivHeading>
                <ClipDivision risk={this.props.data.risk} tab={'vdi'} />
              </div>
              <div className='mb-25'>
                <DivHeading className='navy-color'>Goal</DivHeading>
                <Goal>
                  {this.props.data.goal === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.goal}</>
                  )}
                </Goal>
              </div>
              <div className='mb-25'>
                <DivHeading className='navy-color'>Benchmark</DivHeading>
                <Benchmark>
                  {this.props.data.benchmark === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.benchmark}</>
                  )}
                </Benchmark>
              </div>
              <div className='mb-25'>
                <DivHeading className='navy-color'>
                  Management
                  <TooltipComponent text="Active funds focus on outperforming the market compared to a specific benchmark through a portfolio manager's selections. Passive funds seek to mimic benchmarks by tracking an index." />
                </DivHeading>
                <Management>
                  {this.props.data.management === '' ? (
                    <> &mdash; </>
                  ) : (
                    <>{this.props.data.management}</>
                  )}
                </Management>
              </div>
            </div>
          </ExpandableDiv>
        );
      default:
        return <>No data present</>;
    }
  }
}

MobileExpanded.propTypes = {
  accountType: PropTypes.string,
  data: PropTypes.object,
  tabIndex: PropTypes.number,
};
